import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './statusForm.module.scss';

const PriorAuthStatus = ({ changeStatus }) => {
  const setStatus = (priorAuth) => {
    const data = { priorAuth, status: priorAuth === 'Approved' ? 'Process' : 'Review' };

    changeStatus(data);
  };

  return (
    <div className={classes.status_wrapper}>
      <p>Please process the prior authorization and record the result.</p>

      <div className={classes.btns_wrapper}>
        <Button
          className={classes.max_content}
          title="Approved"
          approveButton
          onClick={() => setStatus('Approved')}
        />

        <Button
          className={classes.max_content}
          title="Denied"
          deniedButton
          onClick={() => setStatus('Denied')}
        />

        <Button
          className={classes.max_content}
          title="Payor restriction"
          copayButton
          onClick={() => setStatus('Payor Restriction')}
        />

        <Button
          className={classes.max_content}
          title="Limited distribution"
          distributionButton
          onClick={() => setStatus('Limited Distribution')}
        />

        <Button
          className={classes.max_content}
          title="Flag for review"
          reviewButton
          onClick={() => setStatus('Review')}
        />
      </div>
    </div>
  );
};

PriorAuthStatus.propTypes = {
  changeStatus: PropTypes.func.isRequired,
};

export default PriorAuthStatus;
